import { Component, Vue, Watch } from 'vue-property-decorator';
import { RadarRouter } from './router';
import { CommonStates } from './services/CommonStates/common.states';
import { DingTalkAuth } from './services/DingTalkAuthentication/ding.talk.auth';
import SpinLoader from './shared/SpinLoader/spin.loader.vue';
import SpinLoaderDark from './shared/SpinLoaderDark/spin.loader.dark.vue';
import * as T_T from 'cryface';
import { AxiosPromise } from './utils/axios.promise';
import { CommonConfig } from './configs/config.common';
import { NoticeConfig } from 'iview';
import { ESessions } from './models/sessions';
import { HybridRoutes } from './routes/hybrid.routes';
import { CallNative } from './services/EpicContextService/call.native';
import { EpicContextService } from './services/EpicContextService/epic.context';

const router = RadarRouter.routerFactory();
// router.beforeEach((to, from, next) => {
//     console.log(to, from, 'router guards');
// });
const store = CommonStates.factory();

@Component({
    components: {
        SpinLoader,
        SpinLoaderDark
    },
    router,
    store,
})
export default class App extends Vue {
    // public authenticated: boolean = false;
    public dingAuthService = new DingTalkAuth();
    public isLoading = false;
    public configCommon = new CommonConfig();

    // @Watch('$store.state.auth', { immediate: true, deep: true })
    // public onAuthed(val: IUserStates, oldVal: IUserStates) {
    //     this.authenticated = val.authentication.succeed;
    //     if (this.authenticated) {
    //         this.isLoading = false;
    //     }
    // }

    private async _authenticate() {
        const userInforStorage = this.checkAuthentication();
        if (T_T.simpleDetect(userInforStorage)) {
            try {
                const userInfo = userInforStorage;
                const authoreyHost = this.configCommon.authoreyHost;
                if (T_T.simpleDetect(userInfo)) {
                    const userId = userInfo.id;
                    const menuListFetched = await AxiosPromise.get(`${authoreyHost}/web/radar/meunlist?yuId=${userId}`);
                    if (menuListFetched.errorCode === 200) {
                        this.getAvatar(this.configCommon.microServHostAvatar, userInfo);
                        this.$store.commit('menuListGottem', menuListFetched.data);
                    }
                    this.$store.commit('authenticated', userInfo);
                    const successNoticeConfig: NoticeConfig = {
                        title: 'Login Succeed',
                        desc: 'Welcome to RIFO-Radar.'
                    };
                    this.$Notice.success(
                        successNoticeConfig
                    );
                    this.isLoading = false;
                } else {
                    this.$Notice.error({
                        title: 'Error',
                        desc: `User Data Fetch Failed.`
                    });
                    this.isLoading = false;
                }
            } catch (e) {
                this.epicAuth();
            }
        } else {
            this.epicAuth();
        }
    }

    public async epicAuth() {
        if (this.dingAuthService.isDingTalk()) {
            this.$Notice.open({
                title: 'DingTalk',
                desc: 'Authenticating-----------------------'
            });
            const userInfo = await this.dingAuthService.authenticate();
            const _this: any = this;
            const browserStore = _this.$browserStore;
            browserStore.setSession(ESessions.UserInfo, JSON.stringify(userInfo));
            const authoreyHost = this.configCommon.authoreyHost;
            if (T_T.simpleDetect(userInfo)) {
                const userId = userInfo.id;
                const menuListFetched = await AxiosPromise.get(`${authoreyHost}/web/radar/meunlist?yuId=${userId}`);
                if (menuListFetched.errorCode === 200) {
                    this.getAvatar(this.configCommon.microServHostAvatar, userInfo);
                    this.$store.commit('menuListGottem', menuListFetched.data);
                }
                this.$store.commit('authenticated', userInfo);
                const successNoticeConfig: NoticeConfig = {
                    title: 'Login Succeed',
                    desc: 'Welcome to RIFO-Radar.'
                };
                this.$Notice.success(
                    successNoticeConfig
                );
                this.isLoading = false;
            } else {
                this.$Notice.error({
                    title: 'DingTalk',
                    desc: `Authenticate Failed.`
                });
                this.isLoading = false;
            }
        } else {
            this.isLoading = false;
            if (!this.freeRoute()) {
                this.$router.push('/login');
            }
        }
    }

    public async created() {
        this.isLoading = true;
        this.routerGuards();
        try {
            CallNative.runSetEpicContext();
        } catch (e) { }
        document.title = T_T.simpleDetect(this.configCommon.appTitle) ? this.configCommon.appTitle : 'RIFO Radar';
        if (!this.freeRoute()) {
            await this._authenticate();
        }
        this.isLoading = false;
    }

    public routerGuards() {
        router.afterEach((to, from) => {
            const appAuthCode = EpicContextService.getParam('appAuthCode');
            const isRIFOApp = T_T.simpleDetect(appAuthCode);
            if (this.$store.state.auth.authentication.succeed) { } else if (this.freeRoute()) {
            } else {
                this.$router.push('/login');
            }
        });
    }

    public freeRoute(to: any = undefined): boolean {
        const hybridRoutes: any[] = HybridRoutes.factory().map((v: any) => v.path);
        const freeRoutes: any[] = hybridRoutes;
        let isFreeToGo = false;
        for (let i = 0; i < freeRoutes.length; i++) {
            if (location.href.indexOf(freeRoutes[i]) > -1) {
                isFreeToGo = true;
            }
        }
        // const browserCheck: boolean = freeRoutes.indexOf(location.href.replace(location.origin, '').replace('/#', '')) > -1;
        if (T_T.simpleDetect(to)) {
            return (freeRoutes.indexOf(to!.path) > -1) || isFreeToGo;
        }
        return isFreeToGo;
    }

    public async getAvatar(uri: string, userInfo: any) {
        const avatarBody = {
            id: userInfo.xPartnerId
        };
        try {
            const avatarFetched = await AxiosPromise.postJson(uri, avatarBody);
            if (T_T.simpleDetect(avatarFetched.data)) {
                if (T_T.simpleDetect(avatarFetched.data.data)) {
                    this.$store.commit('avatarGotten', avatarFetched.data.data.imageUrl);
                }
            }
        } catch (e) { }
    }

    public checkAuthentication() {
        const _this: any = this;
        const browserStore: any = _this.$browserStore;
        try {
            const userInfo = JSON.parse(browserStore.getSession(ESessions.UserInfo));
            return T_T.simpleDetect(userInfo) ? userInfo : undefined;
        } catch (e) { }
        return undefined;
        // const isLogin = _this.$browserStore;
    }
}
